/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";
import AddCircle from "@material-ui/icons/AddCircle";

import { Configs } from "../../../common/config";
import { UrlCollection } from "../../../common/url-collection";
import DeleteDialog from "../../../components/dialog-delete/dialog-delete.view";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../utils/configuration";
import * as viVN from "../../../language/vi-VN.json";
import { getInvestmentErrorMessage } from "../../../common/tools";
import * as projectAction from "../../../redux/store/investment-opportunity/investment-project.store";

import SearchInvestmentProject, { DefaultFilter } from "./search-investment-project.view";
import ListInvestmentProject from "./list-investment-project.view";
import useInvestmentLookups from "./use-investment-lookups";

// Giữ bộ lọc/trang khi chuyển sang form sửa rồi quay lại
let lastQuery = null;

const DefaultQuery = {
  filter: DefaultFilter,
  page: 1,
  rowsPerPage: Configs.DefaultPageSize,
  order: "desc",
  orderBy: "modifiedDate",
};

// Backend nhận: name asc|desc, area asc|desc, modifieddate asc. Bỏ trống = mới cập nhật trước
const toSortingParam = (orderBy, order) => {
  const field = orderBy.toLowerCase();
  if (field === "modifieddate" && order === "desc") return "";
  return field + " " + order;
};

const InvestmentProject = () => {
  const history = useHistory();
  const lookups = useInvestmentLookups();
  const initialQuery = lastQuery || DefaultQuery;

  const [filter, setFilter] = useState(initialQuery.filter);
  const [appliedFilter, setAppliedFilter] = useState(initialQuery.filter);
  const [page, setPage] = useState(initialQuery.page);
  const [rowsPerPage, setRowsPerPage] = useState(initialQuery.rowsPerPage);
  const [order, setOrder] = useState(initialQuery.order);
  const [orderBy, setOrderBy] = useState(initialQuery.orderBy);
  const [data, setData] = useState([]);
  const [totalItemCount, setTotalItemCount] = useState(0);
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    lastQuery = { filter: appliedFilter, page, rowsPerPage, order, orderBy };
    getList();
  }, [appliedFilter, page, rowsPerPage, order, orderBy]);

  const getList = () => {
    projectAction
      .GetListInvestmentProject({
        ...appliedFilter,
        keyword: appliedFilter.keyword.trim(),
        pageIndex: page,
        pageSize: rowsPerPage,
        sorting: toSortingParam(orderBy, order),
      })
      .then((res) => {
        const content = res && res.content;
        if (!content) return;
        // Trang hiện tại trống sau khi xoá bản ghi cuối: lùi về trang trước
        if (content.items.length === 0 && page > 1 && content.totalItemCount > 0) {
          setPage(Math.max(1, content.pageCount));
          return;
        }
        setData(content.items);
        setTotalItemCount(content.totalItemCount);
      })
      .catch((err) => {
        ShowNotification(
          getInvestmentErrorMessage(err),
          NotificationMessageType.Error
        );
      });
  };

  const handleSearch = () => {
    setPage(1);
    setAppliedFilter({ ...filter });
  };

  const handleResetFilter = () => {
    setFilter(DefaultFilter);
    setPage(1);
    setAppliedFilter(DefaultFilter);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleDelete = () => {
    projectAction
      .DeleteInvestmentProject(deleteId)
      .then((res) => {
        setDeleteId(null);
        if (res && res.content && res.content.status) {
          ShowNotification(
            viVN.Success.InvestmentProjectDeleteSuccess,
            NotificationMessageType.Success
          );
          getList();
        }
      })
      .catch((err) => {
        setDeleteId(null);
        ShowNotification(
          getInvestmentErrorMessage(err),
          NotificationMessageType.Error
        );
      });
  };

  return (
    <div className="slider">
      <div className="d-sm-flex align-items-center justify-content-end mb-3">
        <Button
          variant="contained"
          color="primary"
          onClick={() => history.push(UrlCollection.InvestmentProjectAdd)}
          startIcon={<AddCircle />}
        >
          Thêm dự án
        </Button>
      </div>

      <SearchInvestmentProject
        filter={filter}
        setFilter={setFilter}
        onSearch={handleSearch}
        onReset={handleResetFilter}
        lookups={lookups}
      />

      <ListInvestmentProject
        data={data}
        totalItemCount={totalItemCount}
        page={page}
        rowsPerPage={rowsPerPage}
        order={order}
        orderBy={orderBy}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        onRequestSort={handleRequestSort}
        editAction={(id) =>
          history.push(UrlCollection.InvestmentProjectEdit.replace(":id", id))
        }
        deleteAction={setDeleteId}
      />

      {deleteId && (
        <DeleteDialog
          isOpen={!!deleteId}
          onClose={() => setDeleteId(null)}
          onSuccess={handleDelete}
          header={"Xác nhận xóa"}
          content={"Bạn có chắc chắn muốn xóa dự án này?"}
        />
      )}
    </div>
  );
};

export default InvestmentProject;
